<script>
export default {
  name: 'RappiPayModal',
  components: {},
  props: {
    copies: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {},
  created() {},
  methods: {
    getImgUrl: function(name) {
      var image = require.context('@assets/images/', false, /\.png$/)
      return image('./' + name + '.png')
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <div :class="$style.container__title">
      <p>{{ copies.modalTitle }}</p>
    </div>
    <div :class="$style.container__text">
      <p>{{ copies.modalMessage }}</p>
    </div>
    <div :class="$style.container__actions">
      <BaseButton
        full
        @click="$emit('close')"
      >
        OK
      </BaseButton>
    </div>
  </div>
</template>

<style lang="scss" module scoped>
@import '@design';

.container {
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  text-align: center;

  &__title {
    width: 80%;
    font-weight: 600;
    color: $charcoal-gray;

    @extend %typography-medium;
  }

  &__text {
    width: 90%;
    margin: 1rem 0 1rem 0;
    color: $slate-grey;

    @extend %typography-medium;
  }

  &__actions {
    width: 100%;
  }
}
</style>
